import { Navigation, Swiper } from 'swiper'

Swiper.use([Navigation])

if (document.getElementById('page-career-file')) {
  page()
}

function page() {
  const swiperEl = document.querySelector('.careerFileModalSwiper')
  const modalEl = document.querySelector('.careerFile__modal')

  if (!swiperEl || !modalEl) {
    return
  }

  const modalSwiper = new Swiper(swiperEl, {
    slidesPerView: 1,
    speed: 500,
    loop: false,
    autoHeight: false,
    allowTouchMove: false,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: modalEl.querySelector('.careerFileModal__next'),
      prevEl: modalEl.querySelector('.careerFileModal__prev'),
    },
  })

  const getSlideIndexByImage = (imageId) => {
    const slideIndex = Array.from(modalSwiper.slides).findIndex((slide) => slide.id === `madal_${imageId}`)

    return slideIndex >= 0 ? slideIndex : 0
  }

  const adjustCareerFileScroll = (modal) => {
    const inner = modal.querySelector('.careerFileModal__inner')
    const photo = modal.querySelector('.careerFileModal__photo')
    const box = modal.querySelector('.careerFileModal__box')

    if (!inner || !photo || !box) {
      return
    }

    const viewportHeight = inner.clientHeight
    const photoHeight = photo.offsetHeight
    const boxHeight = box.offsetHeight
    const extraScroll = Math.max(0, photoHeight - viewportHeight)

    if (boxHeight >= photoHeight) {
      inner.style.paddingBottom = `${extraScroll}px`
    } else {
      inner.style.paddingBottom = '0px'
    }
  }

  const adjustAllCareerFileScrolls = () => {
    modalEl.querySelectorAll('.careerFileModal').forEach((modal) => {
      adjustCareerFileScroll(modal)
    })
  }

  const resetModalScroll = () => {
    modalEl.querySelectorAll('.js-career-file-modal-scroll').forEach((scrollEl) => {
      scrollEl.scrollTop = 0
      const modalScrollBg = scrollEl.querySelector('.js-modal-scroll-bg')
      if (modalScrollBg) {
        modalScrollBg.dataset.state = 'off'
      }
    })
  }

  const updateModalSwiper = () => {
    requestAnimationFrame(() => {
      modalSwiper.update()
      adjustAllCareerFileScrolls()
    })
  }

  modalSwiper.on('slideChange', () => {
    resetModalScroll()
    updateModalSwiper()
  })

  const modalScrolls = document.querySelectorAll('.js-modal-scroll')
  modalScrolls.forEach((modalScroll) => {
    const update = () => {
      const modalScrollBg = modalScroll.querySelector('.js-modal-scroll-bg')
      if (!modalScrollBg) {
        return
      }

      const maxScroll = modalScroll.scrollHeight - modalScroll.clientHeight
      const isHalf = maxScroll > 0 && modalScroll.scrollTop >= maxScroll / 2

      modalScrollBg.dataset.state = isHalf ? 'on' : 'off'
    }
    modalScroll.addEventListener('scroll', update)
    update()
  })

  window.addEventListener('resize', adjustAllCareerFileScrolls)

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('.careerFileList__block.js-modal-open')
      if (!btn) {
        return
      }

      const imageMatch = btn.id.match(/^btn_(.+)$/)
      if (!imageMatch) {
        return
      }

      const slideIndex = getSlideIndexByImage(imageMatch[1])

      modalSwiper.slideTo(slideIndex, 0)
      resetModalScroll()
      updateModalSwiper()

      window.setTimeout(() => {
        modalSwiper.update()
        adjustAllCareerFileScrolls()
      }, 100)
    },
    true
  )

  updateModalSwiper()

  const hash = location.hash.slice(1)
  const id = hash.startsWith('id=') ? hash.slice(3) : ''

  if (id) {
    history.replaceState(null, '', location.pathname + location.search)

    const btn = document.getElementById(`btn_${id}`)
    btn?.click()
  }
}
